import { Form, Icon, Radio } from '@roo/roo';
import download from '../../../../assets/images/download.png';
import React from 'react';
import { useUpdateEffect } from 'ahooks';
import { get } from 'lodash';
import { useSimpleContext } from '../../_context';
import { UploadField } from '../../_components/UploadField';
import { downloadUrls } from '../../../../utils/config';
import { requiredRule } from '../../../../utils/rules';
import { sendFileLx } from '../../../../utils/lxUtils';
import { useUserContext } from '../../../../components/UserData';
import { getTemplateFileUrl } from '../../../../assets/apis/innovate';
const RadioGroup = Radio.Group;

const { Field } = Form;

export const Project = function (props) {
  const { setFieldValue } = props;
  const { state } = useSimpleContext((t) => [t.innovate.projectDict, t.disabled]);
  const disabled = state.disabled;
  const reportData = state.innovate.projectDict;
  const {
    state: { kechuang_apply_file },
  } = useUserContext((t) => [t.kechuang_apply_file]);

  useUpdateEffect(
    function () {
      setFieldValue('reportDirection', get(reportData, '0.id'));
    },
    [reportData]
  );

  return (
    <div className='form-patch bc' style={{ paddingLeft: 74 }}>
      <Field required={true} name={`reportDirection`} label='项目申报方向' layout={'vertical'}>
        {({ value, handleChange }) => {
          const opts = reportData || [];
          if (!value && value !== 0 && opts.length) {
            handleChange(get(opts, '0.id'));
          }
          return (
            <div>
              <div className='t-info'>
                <Icon name='info-circle-o'></Icon>
                示范项目需聚焦外卖包装以及废弃物处理场景
              </div>
              <RadioGroup value={value} onChange={handleChange} disabled={disabled}>
                {opts.map((item) => {
                  return <Radio value={item.id}>{item.name}</Radio>;
                })}
              </RadioGroup>
            </div>
          );
        }}
      </Field>
      <Field
        required={true}
        rule={{ ...requiredRule }}
        name={`applyFile`}
        label='项目申报书'
        layout={'vertical'}
      >
        {(props) => {
          return (
            <div>
              {/*<div className='t-info' >*/}
              {/*  <Icon name='info-circle-o' />*/}
              {/*  项目申报书内容需包含项目的技术可行性描述、项目有关地方政府资源及合作方、项目预算、项目目前投入资金、项目设社会影响力及环境效益等。*/}
              {/*</div>*/}
              <div className='info normal t-info' style={{ marginBottom: 10 }}>
                <Icon name='info-circle-o' />
                请按模版填写，如未按模版填写信息，作无效申请处理
              </div>
              <div style={{ width: '100%', margin: '16px 0', textAlign: 'right' }}>
                <a
                  style={{ cursor: 'pointer', color: '#222' }}
                  target={'_blank'}
                  href={kechuang_apply_file || downloadUrls.innoApply}
                  onClick={(e) => {
                    sendFileLx(downloadUrls.innoApply);
                  }}
                >
                  <img src={download} alt='' />
                  下载模板
                </a>
               
              </div>
              <UploadField
                value={[props.value]}
                handleChange={(fs) => props.handleChange(fs[0])}
                maxFiles={1}
                type={'doc'}
              />
            </div>
          );
        }}
      </Field>
      <br />
    </div>
  );
};
